<form [formGroup]='contactEmailInfo' class="appointment">
  <div class="customer-dealer-details" [ngClass]="{'adjust-fields': !customerSearch}">
    <!--ASPD-6589 changes(Don't remove)-->
    <div class='customer-type' *ngIf="apptType !=='DIGI_CHK'">
      <mat-checkbox
        [checked]="f.customerType?.value === 'Business'"
        (change)="onCustomerTypeChange($event.checked)">
        {{ 'testDrive.customerType' | translate }}
      </mat-checkbox>
    </div>
    <div class='business-name' *ngIf="f.customerType?.value === 'Business' && apptType !=='DIGI_CHK'">
      <label>{{ 'testDrive.businessName' | translate}}<span style="color:red">*</span></label>
      <mat-form-field appearance="outline">
        <input matInput formControlName='businessName' required>
        <mat-error *ngIf="f.businessName.touched && f.businessName.invalid">{{ 'testDrive.pleaseEnterBusinessName' | translate}}</mat-error>
      </mat-form-field>
    </div>
    <!--ASPD-6589 changes(Don't remove)-->
    <div class="row1" [ngClass]="{'row-width': !customerSearch}">
      <div class='first-name'>
        <label>{{ 'testDrive.firstName' | translate}}<span *ngIf="isControlRequired('firstName')" style="color:red">*</span></label>
        <mat-form-field appearance="outline">
          <input matInput formControlName='firstName' required>
          <mat-error *ngIf="f.firstName.touched && f.firstName.invalid">{{ 'testDrive.pleaseEnterFirstName' | translate}}</mat-error>
        </mat-form-field>
      </div>
      <div class='last-name'>
        <label>{{ 'testDrive.lastName' | translate}}<span *ngIf="isControlRequired('lastName')" style="color:red">*</span></label>
        <mat-form-field appearance="outline">
          <input matInput formControlName='lastName' required>
          <mat-error *ngIf="f.lastName.touched && f.lastName.invalid">{{ 'testDrive.pleaseEnterLastName' | translate}}</mat-error>
        </mat-form-field>
      </div>
    </div>
    <div class="msg" *ngIf="!required  && apptType!=='DIGI_CHK'">
      <label style="color:black">{{ 'testDrive.emailOrPhone' | translate}}</label>            
    </div>
    <div class="row2" [ngClass]="{'row-width': !customerSearch}">
      <div class='mail-id'>
        <label for="emailId">{{ 'testDrive.email' | translate}}<span style="color:red" *ngIf="required">*</span></label>
        <mat-form-field appearance="outline">
          <input id="emailId" matInput formControlName='emailAddress' [required]="required">
          <mat-error *ngIf="f.emailAddress.touched && f.emailAddress.invalid">{{ 'testDrive.pleaseEnterValidEmail' | translate}}</mat-error>
        </mat-form-field>
      </div>
      <div class='contact-number'>
        <label aria-hidden="true">{{ 'testDrive.contactNumber' | translate}}<span style="color:red" *ngIf="required">*</span></label>
        <mat-form-field appearance="outline" class='contact-number'>
          <input matInput type="text" placeholder=""
      formControlName="phoneNumber" appPhoneFormat inputMode="numeric"
      [errorStateMatcher]="matcher"/>
          <mat-error *ngIf="f.phoneNumber.touched && f.phoneNumber.invalid">{{ 'testDrive.PleaseEnterValidPhone' | translate}}</mat-error>
        </mat-form-field>
      </div>
      <div class="search-buttons" *ngIf="customerSearch">
        <button type="button" class="search-btn" (click)="searchCustomer()" [disabled]="disableSearchBtn()">
          <span>{{ 'searchCustomer.search' | translate}}</span>
        </button>
        <div class="error-message" *ngIf="noCustomerFound">
          {{'serviceSchedule.noCustomerResults' | translate}}
        </div>
      </div>
    </div>
    <div class="email" *ngIf="!required">
      <asp-icon name="ic-20-feedback-alert-error.svg" width="1rem"></asp-icon>
      <label aria-hidden="true" *ngIf="apptType!=='DIGI_CHK'" style="color:black;font-weight: bold;">{{ 'testDrive.emailNotification' | translate}}</label>           
      <label aria-hidden="true" *ngIf="apptType==='DIGI_CHK'" style="color:black;font-weight: bold;">{{ 'deliveryChecklist.emailNotification' | translate}}</label>            
    </div>
    <app-do-not-modify-banner *ngIf="contactEmailInfo.controls['drvaFlag'].value"></app-do-not-modify-banner>
  </div>
</form>
